import { Theme } from "@mui/material/styles";

declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        tableOverline: true;
        section: true;
        helper: true;
    }
}

export default function Typography(theme: Theme) {
    return {
        MuiTypography: {
            variants: [
                {
                    props: { variant: "tableOverline" },
                    style: {
                        color: theme.palette.text.secondary,
                    },
                },
                {
                    props: { variant: "section" },
                    style: {
                        color: theme.palette.text.secondary,
                    },
                },
                {
                    props: { variant: "helper" },
                    style: {
                        color: theme.palette.text.secondary,
                    },
                },
            ],
            defaultProps: {
                variantMapping: {
                    section: "h2",
                    helper: "div",
                },
            },
            styleOverrides: {
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
                helper: {
                    flex: 1,
                },
                h3: {
                    "&.MuiTypography-gutterBottom": {
                        marginBottom: theme.spacing(2.5),
                    },
                },
            },
        },
    };
}
